export default __webpack_public_path__ + "static/media/institute-26-min.07784f12.webp";